import {
  APP_INIT,
  ACCOUNT_WALLET_RESET,
  ACCOUNT_CHANGE,
  PAY_WITH_ETH_FEE_UPDATED,
  PAY_WITH_CAT_FEE_UPDATED,
  LATEST_BLOCK_NUMBER_UPDATED,
  RECOMMENDED_GAS_PRICES_UPDATE,
} from '../actionTypes';

export const getDefaultState = () => ({
  payContractAddress: '',
  catPaymentContractAddress: '',
  payWithEthFee: null,
  payWithCatFee: null,
  catTokenContractAddress: '',
  latestBlockNumber: 0,
  recommendedGasPrices: {},
  gasLimits: {},
});

const reducer = (state = getDefaultState(), action) => {
  switch (action.type) {
    case APP_INIT:
      return {
        ...state,
        payContractAddress: action.payContractAddress,
        catPaymentContractAddress: action.catPaymentContractAddress,
        catTokenContractAddress: action.catTokenContractAddress,
        gasLimits: action.gasLimits,
      };

    case ACCOUNT_WALLET_RESET:
    case ACCOUNT_CHANGE:
      return {
        ...state,
        latestBlockNumber: 0,
      };

    case PAY_WITH_ETH_FEE_UPDATED:
      return {
        ...state,
        payWithEthFee: action.fee,
      };

    case PAY_WITH_CAT_FEE_UPDATED:
      return {
        ...state,
        payWithCatFee: action.fee,
      };

    case LATEST_BLOCK_NUMBER_UPDATED:
      return {
        ...state,
        latestBlockNumber: action.blockNumber,
      };

    case RECOMMENDED_GAS_PRICES_UPDATE:
      return {
        ...state,
        recommendedGasPrices: action.recommendedGasPrices,
      };

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/app.js